import { some } from 'lodash-es'
import { useState, useEffect } from 'react'

const getCurrentUrl = () => {
  return typeof window === 'object'
    ? window.location.pathname + window.location.search
    : ''
}

const filterCondition = (nav) => {
  return some(nav, (navChild) => getCurrentUrl().includes(navChild.matchUrl))
}
// 判断navs children中是否有当前ur, 如果有:赋值给secondNavData,供副组件使用
let flag = false
const isCurrentUrlChildren = ({ navChild, inputFlag }) => {
  flag = inputFlag
  if (filterCondition([navChild]) || filterCondition(navChild.children || [])) {
    flag = true
  }
  if (navChild.children && navChild.children.length && !flag) {
    navChild.children.forEach((nav) => {
      isCurrentUrlChildren({
        navChild: nav,
        inputFlag: flag,
      })
    })
  }
  return flag
}
// 查询出用户指定渲染层级的navs children
const handleChildrenData = ({
  navs,
  levelNum,
  renderNavLevel,
  ...resolvedProps
}) => {
  if (levelNum < renderNavLevel) {
    levelNum++
    ;(navs.children || []).forEach((navChild) => {
      handleChildrenData({
        navs: navChild,
        levelNum,
        renderNavLevel,
        ...resolvedProps,
      })
    })
  } else if (levelNum === renderNavLevel) {
    console.log(navs)
    isCurrentUrlChildren({
      navParent: navs,
      navChild: navs,
      ...resolvedProps,
    })
  }
}

const getChildrenIsActive = (navChild, flagArr) => {
  // console.log(navChild)
  if (getCurrentUrl().includes(navChild.matchUrl)) flagArr.push(true)
  else if (navChild.children) {
    navChild.children.forEach((nav) => {
      getChildrenIsActive(nav, flagArr)
    })
  }
  return flagArr
}

// 设置数据高亮状态 and 展开状态
const setDataHighlightState = (navs, isRenderAllLevel) => {
  return navs.map((nav) => {
    let child = null
    if (nav.children) child = setDataHighlightState(nav.children)
    return {
      ...nav,
      children: child,
      isActive:
        getCurrentUrl().includes(nav.matchUrl) ||
        some(getChildrenIsActive(nav, []), Boolean),
      isOpen:
        nav.children &&
        some(getChildrenIsActive(nav, []), Boolean) &&
        isRenderAllLevel,
    }
  })
}

export {
  getCurrentUrl,
  handleChildrenData,
  setDataHighlightState,
  isCurrentUrlChildren,
}

export const useWindowSize = () => {
  const getClientSize = () => {
    let clientSize = ''
    if (window.innerWidth >= 1920) clientSize = 'big'
    else if (window.innerWidth < 1920 && window.innerWidth > 1200) {
      clientSize = 'middle'
    } else clientSize = 'small'
    return clientSize
  }
  // 第一步：声明能够体现视口大小变化的状态
  const [windowSize, setWindowSize] = useState({
    clientWidth: window.innerWidth,
    clientHeight: window.innerHeight,
    clientSize: getClientSize(),
  })

  // 第二步：通过生命周期 Hook 声明回调的绑定和解绑逻辑
  useEffect(() => {
    const updateSize = () => {
      setWindowSize({
        clientWidth: window.innerWidth,
        clientHeight: window.innerHeight,
        clientSize: getClientSize(),
      })
    }
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return windowSize
}
